import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductTestListDTO extends TeamAccessDTO {

    title: string;

    description: string;

    successful: boolean;
    
}
